import React, {useState, useEffect} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Button,
  Modal,
  ModalHeader
} from "reactstrap";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import FormCampanha from "./Form";
import './style.css'
import useToggle from 'lib/useToggle'
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'

/* Retorna quantos dias faltam para o encerramento (negativo = já passou) */
const diasParaEncerrar = (dateStr) => {
  if (!dateStr || dateStr === '00/00/0000') return null;
  const parts = dateStr.split('/');
  if (parts.length !== 3) return null;
  const [d, m, y] = parts;
  const date = new Date(y, m - 1, d);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  return Math.floor((date - hoje) / (1000 * 60 * 60 * 24));
};

const Campanha = () => {

  const { SearchBar }                     = Search;
  const [campanha_id, setCampanha_id]     = useState("");
  const [modal, setModal]                 = useToggle(false);
  const [loading, setLoading]             = useState(true);
  const [ListaCampanha, setListaCampanha] = useState([]);

  const colunas = [
    {
      dataField: 'campanha_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'campanha',
      text: 'Nome',
      align: 'left',
      headerAlign: 'left',
      classes: 'col-nome-left',
      headerClasses: 'col-nome-left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'horario_inicio',
      text: 'Inicio',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (cellContent+' hs')}
    },
    {
      dataField: 'horario_fim',
      text: 'Fim',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (cellContent+' hs')}
    },
    {
      dataField: 'data_encerramento',
      text: 'Encerramento',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent) => {
        const dias = diasParaEncerrar(cellContent);
        if (dias === null) return cellContent;

        let dateColor      = undefined;
        let dateDecoration = undefined;
        let iconClass      = null;
        let iconTitle      = '';

        if (dias < 0) {
          dateColor      = '#94a3b8';
          dateDecoration = 'line-through';
          iconClass      = 'fa fa-ban';
          iconTitle      = 'Campanha encerrada';
        } else if (dias === 0) {
          dateColor = '#dc2626';
          iconClass = 'fa fa-exclamation-circle';
          iconTitle = 'Encerra hoje!';
        } else if (dias === 1) {
          dateColor = '#dc2626';
          iconClass = 'fa fa-exclamation-circle';
          iconTitle = 'Encerra amanhã!';
        } else if (dias <= 7) {
          dateColor = '#d97706';
          iconClass = 'fa fa-clock';
          iconTitle = `Encerra em ${dias} dias`;
        }

        return (
          <span style={{ color: dateColor, textDecoration: dateDecoration }}>
            {iconClass && (
              <i
                className={iconClass}
                title={iconTitle}
                style={{ marginRight: '5px', fontSize: '12px' }}
              />
            )}
            {cellContent}
          </span>
        );
      }
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {
        if (cellContent === 'S') {
          return (<div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>)
        } else {
          return (<div className="timeline-heading"><span className="badge badge-info badge-pill m-0 aberto">Não</span></div>)
        }
      }
    }
  ]

  const listaCampanha = ()=>{

    const url     = rotas.campanha;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success && ret.success === 'S'){
        setListaCampanha(ret.lista)
      }else{
        setListaCampanha([])
      }
      setLoading(false);
    })
  }

  const abreModal = (id) => {
    setCampanha_id(id);
    setModal();
  }

  const fechaModal = (valor) => {
    listaCampanha();
    setModal();
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaCampanha();
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return(
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>

                <CardHeader>
                  <CardTitle>CAMPANHA</CardTitle>
                </CardHeader>
                <CardBody>

                <ToolkitProvider
                      search
                      keyField  = "campanha_id"
                      data      = {ListaCampanha}
                      columns   = {colunas}
                    >
                      {
                        props => (
                          <div>
                            <Container>
                              <Modal
                                key     = 'modalT'
                                size    = 'xl'
                                isOpen  = {modal}
                              >
                                <ModalHeader>Cadastro da campanha</ModalHeader>
                                <FormCampanha
                                  campanha_id     = {campanha_id}
                                  setCampanha_id  = {setCampanha_id}
                                  recarregaLista  = {listaCampanha}
                                  fechaModal      = {fechaModal}
                                >
                                </FormCampanha>
                              </Modal>
                              <Row>
                                <Col md="3">
                                  <Button
                                    outline
                                    className = "m-0 w-100"
                                    color     = "primary"
                                    style     = {{ padding: '5px 20px' }}
                                    onClick   = {() => abreModal('')}
                                  >
                                    <i className="fas fa-plus" />
                                    Cadastrar
                                  </Button>
                                </Col>

                                <Col md="9">
                                  <SearchBar
                                    placeholder = "Buscar Campanha..."
                                    style       = {{ padding: '5px' }}
                                    {...props.searchProps}
                                  />
                                </Col>
                              </Row>
                            </Container>

                            <hr />

                            <BootstrapTable
                              striped
                              keyField          = 'campanha_id'
                              data              = {ListaCampanha}
                              columns           = {colunas}
                              noDataIndication  = "Nenhum registro encontrado"
                              pagination        = {paginationFactory({
                                                    sizePerPage: 10,
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    showTotal: false,
                                                  })}
                              rowStyle          = {{ cursor: "pointer" }}
                              rowEvents         = {{
                                                    onDoubleClick: (e, row, rowIndex) => {
                                                      abreModal(row.campanha_id)
                                                    }
                                                  }}
                              {...props.baseProps}                           
                            />
                          </div>
                        )
                      }
                    </ToolkitProvider>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
export default Campanha
